import React from "react";
import { Route, Routes } from "react-router-dom";
import UnpaidInvs from "../pages/unpaid/UnpaidInvs";

export default function UnpaidInvsRoutes() {
  return (
    <Routes>
      <Route path="" element={<UnpaidInvs />} />
    </Routes>
  );
}
